import { Pipe, PipeTransform } from '@angular/core';
import { TEXT_CASE } from '@sharedModels/app-types';

@Pipe({
  name: 'convertCase'
})

export class ConvertCasePipe implements PipeTransform {

  /**
   * transform
   * @param value - Text
   * @param args - [From TEXT_CASE, To TEXT_CASE]
   * @returns string - String in To TEXT_CASE
   */
  transform(value: string, ...args: TEXT_CASE[]): string {
    switch(args[0][0]) {
      case TEXT_CASE.UPPER_SNAKE:
        return this.getLowerCase(value, TEXT_CASE.UPPER_SNAKE).split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')
      default:
        return value
    }
  }

  /**
   * getLowerCase
   * @param value - Text
   * @param fromCase - Case of passed text value
   * @returns string - Lowercase of value
   */
  getLowerCase(value: string, fromCase: TEXT_CASE): string {
    switch(fromCase) {
      case TEXT_CASE.UPPER_SNAKE:
        return value.split('_').join(' ').toLowerCase()
    }
  }
}
